import { getAnalyticsPagePath } from "./analyticsUrl";
import { trackNewcomerAction } from "./registrationOnboardingAnalytics";

const impressionKeys = new Set();

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null)
  );

export const trackGAEvent = (eventName, params = {}) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;

  window.gtag("event", eventName, cleanParams(params));
};

const buildAuthEventParams = (extra = {}) => ({
  page_path:
    typeof window !== "undefined"
      ? getAnalyticsPagePath(window.location)
      : "",
  ...extra,
});

const buildBaseEventParams = (event, extra = {}) => ({
  event_id: String(event?.id ?? ""),
  event_name_text: String(event?.name ?? ""),
  event_type: String(event?.type ?? ""),
  event_format: Number(event?.event_format ?? -1),
  host_format: Number(event?.host_format ?? -1),
  fee_type: Number(event?.fee_type ?? -1),
  is_promoted: Boolean(event?.is_promoted ?? event?.promoted),
  is_main_event: Boolean(event?.is_main_event),
  page_path:
    typeof window !== "undefined"
      ? getAnalyticsPagePath(window.location)
      : "",
  ...extra,
});

const buildBaseClubParams = (club, extra = {}) => ({
  club_id: String(club?.id ?? ""),
  club_name_text: String(club?.name ?? ""),
  page_path:
    typeof window !== "undefined"
      ? getAnalyticsPagePath(window.location)
      : "",
  ...extra,
});

export const trackEventCardImpression = (event, extra = {}) => {
  const key = [
    extra.surface || "",
    extra.list_type || "",
    extra.section || "",
    event?.id ?? "",
  ].join(":");

  if (impressionKeys.has(key)) return;
  impressionKeys.add(key);

  trackGAEvent(
    "event_card_impression",
    buildBaseEventParams(event, {
      surface: extra.surface || "",
      list_type: extra.list_type || "",
      section: extra.section || "",
      position_index: extra.position_index ?? null,
    })
  );
};

export const trackEventCardOpen = (event, extra = {}) => {
  trackGAEvent(
    "event_card_open",
    buildBaseEventParams(event, {
      surface: extra.surface || "",
      list_type: extra.list_type || "",
      open_mode: extra.open_mode || "",
      section: extra.section || "",
      position_index: extra.position_index ?? null,
    })
  );
};

export const trackEventDetailsView = (event, extra = {}) => {
  trackGAEvent(
    "event_details_view",
    buildBaseEventParams(event, {
      surface: extra.surface || "",
      list_type: extra.list_type || "",
      open_mode: extra.open_mode || "",
    })
  );
};

export const trackEventJoinClick = (event, extra = {}) => {
  trackNewcomerAction(event?.id, "join_request");
  trackGAEvent(
    "event_join_click",
    buildBaseEventParams(event, {
      surface: extra.surface || "",
      list_type: extra.list_type || "",
      open_mode: extra.open_mode || "",
    })
  );
};

export const trackEventJoinSuccess = (event, extra = {}) => {
  trackNewcomerAction(event?.id, "join_client_success");
  trackGAEvent(
    "event_join_success",
    buildBaseEventParams(event, {
      surface: extra.surface || "",
      list_type: extra.list_type || "",
      open_mode: extra.open_mode || "",
    })
  );
};

export const trackClubCardImpression = (club, extra = {}) => {
  const key = [
    "club",
    extra.surface || "",
    extra.list_type || "",
    extra.section || "",
    club?.id ?? "",
  ].join(":");

  if (impressionKeys.has(key)) return;
  impressionKeys.add(key);

  trackGAEvent(
    "club_card_impression",
    buildBaseClubParams(club, {
      surface: extra.surface || "",
      list_type: extra.list_type || "",
      section: extra.section || "",
      position_index: extra.position_index ?? null,
    })
  );
};

export const trackClubCardOpen = (club, extra = {}) => {
  trackGAEvent(
    "club_card_open",
    buildBaseClubParams(club, {
      surface: extra.surface || "",
      list_type: extra.list_type || "",
      open_mode: extra.open_mode || "details",
      section: extra.section || "",
      position_index: extra.position_index ?? null,
    })
  );
};

export const trackSignupView = (extra = {}) => {
  trackGAEvent(
    "signup_view",
    buildAuthEventParams({
      register_mode: extra.register_mode || "classic",
      referral_present: Boolean(extra.referral_present),
      next_path: extra.next_path || "",
    })
  );
};

export const trackSignupStart = (extra = {}) => {
  trackGAEvent(
    "signup_start",
    buildAuthEventParams({
      register_mode: extra.register_mode || "classic",
      referral_present: Boolean(extra.referral_present),
      country: extra.country || "",
      language: extra.language || "",
      next_path: extra.next_path || "",
    })
  );
};

export const trackSignupSuccess = (extra = {}) => {
  trackGAEvent(
    "signup_success",
    buildAuthEventParams({
      register_mode: extra.register_mode || "classic",
      referral_present: Boolean(extra.referral_present),
      country: extra.country || "",
      language: extra.language || "",
      next_path: extra.next_path || "",
      registered_user_id: extra.registered_user_id || "",
    })
  );
};
